import { render } from "./ConsentContracts.vue?vue&type=template&id=34501e09&scoped=true"
import script from "./ConsentContracts.vue?vue&type=script&lang=js"
export * from "./ConsentContracts.vue?vue&type=script&lang=js"

import "./ConsentContracts.vue?vue&type=style&index=0&id=34501e09&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34501e09"]])

export default __exports__